import { render, staticRenderFns } from "./DesignerReservation.vue?vue&type=template&id=4f08ca76"
import script from "./DesignerReservation.vue?vue&type=script&lang=js"
export * from "./DesignerReservation.vue?vue&type=script&lang=js"
import style0 from "./DesignerReservation.vue?vue&type=style&index=0&id=4f08ca76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports